<template>
  <div class="element-input element-car-content-checkbox">
    <div class="label">{{ label }}</div>
    <ul>
      <li
        :class="[{ on : item.value != '' }]" 
        v-for="(item, index) in items" @click="selectItem( index, item.value )" >
        <div class="container" >
          <div class="item-label">{{ item.label }}</div>
          <div class="item-sublabel" >{{ item.subLabel || item.default }}</div>
        </div>
        <div class="function"><i class="fa fa-angle-right"></i></div>
      </li>
    </ul>
    <div class="error" v-if="error">{{ error }}</div>
  </div>
</template>
<script>
export default {
  props: [ "value", "label", "error", "items", "index", "statusPopup" ],
  data() {
    return {
      status: {
        popup: false,
        index: '',
        option: -1,
      },
      currentStep: 0,
      auto: '',
    }
  },
  computed: {
    isMultiple(){
      return this.items && this.items.length > 1;
    },
    model: {
      get(){
        return this.value;
      },
      set( value ){
        this.$emit( "input", value );
      }
    }
  },
  created(){
    this.$watch( "isMultiple", isMultiple => {
      //this.currentStep = this.value.length;

      if( isMultiple && !Array.isArray( this.value ) ){
        this.$emit( "input", []);
      };
    }, { immediate: true });
  },
  methods: {
    changeStatus(){
      currentStep = this.status.index+1;
    },
    selectItem( index, value ){
      if(this.status.index != index && this.status.popup){
        this.status.popup = true;
        this.status.option = this.index;
        this.status.index = index;
      } else {
        this.status.popup = !this.status.popup;
        this.status.option = this.index;
        this.status.index = index;
      }
      /*if( index >= this.value.length ) {
        this.currentStep = this.currentStep + 1;
      }
      else {
        this.currentStep = index+1;
      }*/

      if(this.currentStep == 2){
        this.auto = this.items[0].subLabel;

        this.$emit( "checkAuto", this.auto );
      }
      else{
        this.$emit( "checkAuto", '' );
      }

      this.$emit( "statusSearchOptions", this.status );

      /*
      if( this.isMultiple ){
        if( this.value.indexOf( value ) >= 0 ){
          this.$emit( "input", this.value.filter( o => o != value ) );
        }else{
          this.$emit( "input", this.value.concat( [ { label: this.items[index].label, value: this.items[index].value } ] ) );
        };
      }else{
        if( this.value ){
          this.$emit( "input", false );
        }else{
          this.$emit( "input", true );
        };
      };
      */
    }
  }
}
</script>
